import { observable, configure, action, computed, toJS } from 'mobx';
import StoreModel from './storeModel';
import util from '../lib/util';

configure({ enforceActions: 'always' });

class ProductStore extends StoreModel {
    constructor() {
        super('product', {
            namePlural: 'products',
            sort: 'maingroupsort,intermediategroupsort,subgroupsort,sort,articleno',
            api: {
                search: {
                    url: '/api/products/',
                    params: {
                        extendedView: 1,
                        limit: 15,
                        sort: 'id',
                    },
                },
                load: {
                    url: '/api/products/',
                    params: {},
                },
                save: {
                    url: '/api/products/',
                    params: {},
                },
            },
            extendedView: 1,
            queryFilter: {
                brand: 'simms',
            },
        });
    }

    @observable product = {};

    @observable products = [];

    @observable updateAll = true;

    @action
    toggleUpdateAll() {
        this.updateAll = !this.updateAll;
    }

    makeQuery() {
        const query = toJS(this.queryFilter);
        if (query.search) {
            delete query.brand;
            delete query.mainCat;
            delete query.intCat;
            delete query.subCat;
        }
        return query;
    }

    @action
    parseElements() {
        this.products.forEach((product, idx) => {
            const ratingKeys = Object.keys(product.ratings || {});
            const sum = ratingKeys
                .map(dealerNum => product.ratings[dealerNum].rating)
                .reduce((a, b) => a + b, 0);
            const avg = sum / ratingKeys.length || 0;
            this.products[idx].avg = avg;
            this.products[idx].avgTot = ratingKeys.length;
        });
    }

    getElement(idx) {
        const index = idx || this.searchSelectIdx;
        return {
            id: this.searchResults[index].id,
            name: this.searchResults[index].name,
            articleno: this.searchResults[index].articleno,
        };
    }

    @action
    addImage(id, imageObject, object, keyName = 'imgs') {
        const prod = this.product.id ? this.product : this.products.find(e => e.id === id);
        if (typeof prod === 'object') {
            let maxNum = 0;
            if (typeof prod[keyName] === 'object') {
                const imgKeys = Object.keys(prod[keyName]);
                for (let i = 0, l = imgKeys.length; i < l; i += 1) {
                    const key = parseInt(imgKeys[i], 10);
                    if (key > maxNum) {
                        maxNum = key;
                    }
                }
            } else {
                prod[keyName] = {};
            }
            const nextNum = maxNum + 1;
            const newImage = {
                ...imageObject,
                sort: nextNum,
            };
            prod[keyName][nextNum] = newImage;
            const filter = {
                id,
                maingroupid: object.maingroupid,
                intermediategroupid: object.intermediategroupid,
                nameDisplay: object.nameDisplay,
                colorId: object.colorId,
            };
            if (this.updateAll && filter.maingroupid && filter.intermediategroupid && filter.nameDisplay) {
                this.updateMany(filter, keyName, prod[keyName], true);
            } else {
                this.saveField(id, keyName, prod[keyName], true);
            }
        }
    }

    @action
    delImage(id, imageId, object, keyName = 'imgs') {
        const prod = this.product.id ? this.product : this.product.find(e => e.id === id);
        if (typeof prod === 'object' && typeof prod[keyName] === 'object') {
            delete prod[keyName][imageId];
            const imageArray = util.makeArrayOfObject(prod[keyName]);
            prod[keyName] = util.makeObjectOfArray(imageArray);
            const filter = {
                id,
                maingroupid: object.maingroupid,
                intermediategroupid: object.intermediategroupid,
                nameDisplay: object.nameDisplay,
                colorId: object.colorId,
            };
            if (this.updateAll && filter.maingroupid && filter.intermediategroupid && filter.nameDisplay) {
                this.updateMany(filter, keyName, prod[keyName], true);
            } else {
                this.saveField(id, keyName, prod[keyName], true);
            }
        }
    }
}

const store = new ProductStore();
export default store;



// WEBPACK FOOTER //
// ./stores/product.js